import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authLogout } from '@/actions/AuthActions';
import { GuestHeader } from '@/components/modules/Layout/Header/Guest';
import { propBool, propFunc, propOneOf, propStr, } from '@/helpers/custom-prop-types';
import { useBoolState } from '@/hooks/state/useBoolState';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { CLASS_HEADER_Z_INDEX, CLASS_NAME_HEADER, } from '@/utils/constants/element/layout';
import { isClient, isFreeProfessional, isProfessional, } from '@/utils/resources/auth/authResource';
import { isCanUseProffitSearch } from '@/utils/resources/profile/profileResource';
import HeaderClient from './Client';
import HeaderProfessional from './Professional';
/**
 * TODO: TS化 & tailwind化
 */
const Header = (props) => {
    const { guestHeaderViewMode, headerClassName, onChangeKeyword, onChangeSearch, onClickGuestHeaderMenu, onSubmitSearch, showSearch, } = props;
    const dispatch = useDispatch();
    const location = useLocation();
    const { auth, profile } = useSelector((state) => ({
        auth: state.auth,
        profile: state.profile,
    }));
    const { rfp_unread_count: rfpUnreadCount } = useTypeSelector((state) => state.clientRfpCount);
    const { boolState: isShowSpHum, changeFalse: hideSpHum, changeToggle: toggleSpHum, } = useBoolState();
    const onClickLogout = useCallback(() => {
        dispatch(authLogout());
    }, [dispatch]);
    const type = useMemo(() => {
        if (isProfessional(auth) || isFreeProfessional(auth)) {
            return 'professional';
        }
        if (isClient(auth)) {
            return 'client';
        }
        return 'guest';
    }, [auth]);
    const isShowProffitSearch = isCanUseProffitSearch(profile);
    if (type === 'guest') {
        return (_jsx(GuestHeader, { className: clsx('fixed top-0 left-0 right-0', `${CLASS_NAME_HEADER} tw`, CLASS_HEADER_Z_INDEX), onClickGuestHeaderMenu: onClickGuestHeaderMenu, viewMode: guestHeaderViewMode }));
    }
    if (type === 'client') {
        return (_jsx(HeaderClient, { className: headerClassName, location: location, onChangeKeyword: onChangeKeyword, onChangeSearch: onChangeSearch, onClickLogout: onClickLogout, onSubmitSearch: onSubmitSearch, profile: profile, rfpUnreadCount: rfpUnreadCount, showSearch: showSearch }));
    }
    return (_jsx(HeaderProfessional, { hideSpHum: hideSpHum, isShowProffitSearch: isShowProffitSearch, isShowSpHum: isShowSpHum, toggleSpHum: toggleSpHum }));
};
Header.propTypes = {
    guestHeaderViewMode: propOneOf(['normal', 'expand']).isRequired,
    headerClassName: propStr(),
    onChangeKeyword: propFunc(),
    onChangeSearch: propFunc(),
    onClickGuestHeaderMenu: propFunc(),
    onSubmitSearch: propFunc(),
    showSearch: propBool().isRequired,
};
Header.defaultProps = {
    headerClassName: '',
    onChangeKeyword: undefined,
    onChangeSearch: undefined,
    onClickGuestHeaderMenu: undefined,
    onSubmitSearch: undefined,
};
export default Header;
